import { render } from "./RfpCategoryBox.vue?vue&type=template&id=b629b738&scoped=true&ts=true"
import script from "./RfpCategoryBox.vue?vue&type=script&lang=ts"
export * from "./RfpCategoryBox.vue?vue&type=script&lang=ts"

import "./RfpCategoryBox.vue?vue&type=style&index=0&id=b629b738&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b629b738"]])

export default __exports__